import {Platform} from 'react-native';

export const getQueryParameterByName = (name: string, url: string = ''): string | null => {
  if (Platform.OS === 'web' && !url) {
    url = window.location.href;
  }
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const normalizeUrl = (url: string) => {
  if (!url) {
    return '';
  }

  let normalized = url;
  while (normalized.charAt(0) === '/') {
    normalized = normalized.substring(1);
  }

  if (!normalized.startsWith('http')) {
    normalized = `http://${normalized}`;
  }

  return normalized;
};
